import React, { useEffect, useState } from "react";
import "./GenOverView.css";
import { useDispatch, useSelector } from "react-redux";
import NetContractual from "./NetContractual";
import ExcessShortFall from "./ExcessShortFall";
import ActualPrACLineLoss from "./ActualPRACLineLoss";
import NetContractualShortFall from "./NetContractualShortFall";
import AcutalPR from "./AcutalPR";
import {
  acLineLossActualPrAction,
  GHIGTIAction,
  netContractualEnergyShortfallAction,
} from "../../actions/energyAction";
import PvsystActualGTI from "../diagonisticModel/PvsystActualGTI";
import NetPVsystContainer from "./NetPVsystContainer";
import NetContractualContainer from "./NetContractualContainer";
import ActualPRAcAndDcCUFContainer from "./ActualPRAcAndDcCUFContainer";
import ACLineLoss from "./ACLineLoss";
import { Box, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";

const GenOverView = ({ selectedLebel, scbsmbDetail, databaseStr }) => {
  const { projectDetail = {} } = useSelector((state) => state.projectDetail);

  const { netContractualEnergyShortfall = [], loading } = useSelector(
    (state) => state.netContractualEnergyShortfall
  );
  const { acLineLossActualPr = [], loading2 } = useSelector(
    (state) => state.acLineLossActualPr
  );

  const { GHIGTI = [], loading: GHIGTILoader } = useSelector(
    (state) => state.GHIGTI
  );

  /* ###   Initialize State to animate progress bar   ### */

  const [progressValueAnimate, setProgressValueAnimate] = useState({
    progress1: false,
    progress2: false,
    progress3: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    if (selectedLebel?.endTimestamp &&  databaseStr) {
      // console.log("hre1")
      dispatch(netContractualEnergyShortfallAction(selectedLebel, databaseStr));
      dispatch(acLineLossActualPrAction(selectedLebel, databaseStr));
      dispatch(GHIGTIAction(selectedLebel, databaseStr));
    }
  }, [dispatch, selectedLebel?.endTimestamp, selectedLebel?.startTimestamp,databaseStr]);

  useEffect(() => {
    if(databaseStr){
      // console.log("hre2")
   dispatch(GHIGTIAction({dateRangeType:"month"}, databaseStr));
    dispatch(netContractualEnergyShortfallAction({dateRangeType:"month"}, databaseStr));
    dispatch(acLineLossActualPrAction({dateRangeType:"month"}, databaseStr));
    }
 
  }, [location.pathname,databaseStr,dispatch]);
  // console.log("selected label ",selectedLebel)
  return (
    <>
      {
        // loading3 ? (
        //   <SpinLoader />
        // ) :
        <>
          <Grid container xl={12} textAlign={"center"}>
            {/* ###   GenOverview Container 1 Start   ### */}
            <Grid
              // sx={{ boxShadow: 2 }}
              container
              xs={11.8}
              // columnGap={"1vmax"}
              // rowGap={"1vmax"}
              style={{
                boxSizing: "border-box",
                borderWidth: "3px",
                // borderRadius: "8px",
                margin: "0.5vmax auto",
                padding: "0.5vmax",
                background:
                  "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                }}
              //                 sx={{
              //   display: "grid",
              //   // Default (xs/sm): All full width (stacked)
              //   gridTemplateColumns: "1fr",
              //   gap: "16px",

              // }}
              // sx={{
              //   display: "grid",
              //   gap: "16px",

              //   // Default (xs/sm): All full width (stacked)
              //   gridTemplateColumns: "1fr", // Single column

              //   // Medium (md): First full width, next two 50% below
              //   "@media (min-width: 900px)": {
              //     gridTemplateColumns: "1fr 1fr", // 2 columns
              //     "& > :nth-of-type(1)": {
              //       gridColumn: "1 / -1", // Force full width (span all columns)
              //     },
              //     "& > :nth-of-type(2)": {
              //       gridColumn: "1 / 2", // First half of second row
              //     },
              //     "& > :nth-of-type(3)": {
              //       gridColumn: "2 / 3", // Second half of second row
              //     },
              //   },

              //   // Large (lg): All three equal columns
              //   "@media (min-width: 1200px)": {
              //     gridTemplateColumns: "1fr 1fr 1fr", // 3 columns
              //     "& > *": {
              //       gridColumn: "auto/auto auto", // Reset to auto placement
              //     },
              //   },
              // }}

              sx={{
                display: "grid",
                // Default (xs): 1 column (full width)
                gridTemplateColumns: "1fr",
                // sm: 1 column (full width)
                "@media (min-width: 600px)": {
                  gridTemplateColumns: "1fr",
                },
                // md: 1 column (full width)
                "@media (min-width: 900px)": {
                  gridTemplateColumns: "1fr",
                },
                // lg: 2 columns (50% each with gap)
                "@media (min-width: 1200px)": {
                  gridTemplateColumns: "4fr 3fr 3fr",
                },
                gap: "0.5vmax", // Gap only applies in lg view
              }}
            >
              {projectDetail?.plantDataAvailability?.netPVsyst ? (
                <NetPVsystContainer
                  progressValueAnimate={progressValueAnimate}
                  setProgressValueAnimate={setProgressValueAnimate}
                  netContractualEnergyShortfall={netContractualEnergyShortfall}
                  loading={loading}
                />
              ) : (
                <NetContractualContainer
                  progressValueAnimate={progressValueAnimate}
                  setProgressValueAnimate={setProgressValueAnimate}
                  netContractualEnergyShortfall={netContractualEnergyShortfall}
                  loading={loading}
                />
              )}

              <ActualPRAcAndDcCUFContainer
                acLineLossActualPr={acLineLossActualPr}
                loading={loading2}
              />
              <ACLineLoss
                acLineLossActualPr={acLineLossActualPr}
                loading={loading2}
              />
            </Grid>

            {/* ###   GenOverview Container 3 end ### */}
            <Grid
              item
              xl={11.8}
              lg={11.8}
              md={11.8}
              sm={11.8}
              xs={11.8}
              // borderRadius={"14px"}
              style={{
                background:
                  "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                margin: "0vmax auto 0.5vmax",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0.5vmax",
              }}
            >
              <NetContractual
                showPVsystEnergy={
                  projectDetail &&
                  projectDetail?.plantDataAvailability?.netPVsyst
                    ? true
                    : false
                }
                netContractualEnergyShortfall={netContractualEnergyShortfall}
                loading={loading}
              />
            </Grid>
            {/* ###   GenOverview Container 3 end ### */}
            <Grid
              item
              xl={11.8}
              lg={11.8}
              md={11.8}
              sm={11.8}
              xs={11.8}
              // borderRadius={"14px"}
              style={{
                background:
                  "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                margin: "0vmax auto 0.5vmax",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0.5vmax",
              }}
            >
              <ExcessShortFall
                showPVsystEnergy={
                  projectDetail &&
                  projectDetail?.plantDataAvailability?.netPVsyst
                    ? true
                    : false
                }
                netContractualEnergyShortfall={netContractualEnergyShortfall}
                loading={loading}
              />
            </Grid>
            {/* ###   GenOverview Container 4 start ### */}

            <Grid
              item
              xl={11.8}
              lg={11.8}
              md={11.8}
              sm={11.8}
              xs={11.8}
              // borderRadius={"14px"}
              style={{
                background:
                  "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                margin: "0vmax auto 0.5vmax",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0.5vmax",
              }}
            >
              <ActualPrACLineLoss
                acLineLossActualPr={acLineLossActualPr}
                loading2={loading2}
              />
            </Grid>
            {/* ###   GenOverview Container 4 end ### */}
            {/* ###   GenOverview Container 5 start ### */}

            <Grid
              item
              xl={11.8}
              lg={11.8}
              md={11.8}
              sm={11.8}
              xs={11.8}
              // borderRadius={"14px"}
              style={{
                background:
                  "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                margin: "0 auto 0.5vmax",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0.5vmax",
              }}
            >
              <Grid
                container
                sx={{
                  display: "grid",
                  // Default (xs): 1 column (full width)
                  gridTemplateColumns: "1fr",
                  // sm: 1 column (full width)
                  "@media (min-width: 600px)": {
                    gridTemplateColumns: "1fr",
                  },
                  // md: 1 column (full width)
                  "@media (min-width: 900px)": {
                    gridTemplateColumns: "1fr",
                  },
                  // lg: 2 columns (50% each with gap)
                  "@media (min-width: 1200px)": {
                    gridTemplateColumns: "1fr 1fr",
                  },
                  gap: "0.5vmax", // Gap only applies in lg view
                }}
              >
                <Grid
                  sx={{
                    position: "relative",
                    backgroundColor: "#fff",
                    padding: "0.5vmax",
                    overflow: "auto",
                  }}
                >
                  <NetContractualShortFall
                    netContractualEnergyShortfall={
                      netContractualEnergyShortfall
                    }
                    loading={loading}
                    projectDetail={projectDetail}
                  />
                </Grid>
                <Grid
                  sx={{
                    position: "relative",
                    backgroundColor: "#fff",
                    padding: "0.5vmax",
                    overflow: "auto",
                  }}
                >
                  <PvsystActualGTI
                    barColors={["#298c8c", "#f3bc00"]}
                    //  barColors={["#ea801c","#f2c45f"]}
                    //  barColors={[colors3[0],colors3[1]]}
                    GHIGTI={GHIGTI}
                    loading={GHIGTILoader}
                  />

                  {/* <AcutalPR
                      acLineLossActualPr={acLineLossActualPr}
                      loading={loading2}
                    /> */}
                </Grid>
              </Grid>

              {/* ###   GenOverview Container 5 end ### */}
            </Grid>

            {/* ###   GenOverview Container 6 start ### */}
            <Grid container xl={12}>
              <Grid
                item
                xl={11.8}
                lg={11.8}
                md={11.8}
                sm={11.8}
                xs={11.8}
                // borderRadius={"14px"}
                style={{
                  background:
                    "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                  margin: "0 auto 0.5vmax",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0.5vmax",
                }}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    background: "white",
                    padding: "0.5vmax 0.5vmax",
                    position: "relative",
                    overflow: "auto",
                  }}
                >
                  <AcutalPR
                    acLineLossActualPr={acLineLossActualPr}
                    loading={loading2}
                  />
                </Grid>
              </Grid>
              {/* ###   GenOverview Container 6 end ### */}
            </Grid>
          </Grid>
          {/* )} */}
        </>
      }
    </>
  );
};

export default GenOverView;
